<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" />
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="4" lg="2" class="text-center p-2" v-for="button in buttons" :key="button.value">
                        <div :class="{'grey-background': activeButton === button.value, 'font-color-98A2B3': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                            {{ button.label }}
                        </div>
                    </CCol>
    
                </CRow>
            </CCard>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div v-if="activeButton === 'detail'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717">Payment Setting</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Currency</h3>
                                <v-select v-model="selectedCountries" :options="countriesOptions" label="CountrySymbol"></v-select>
                            </CCol>
                            <CCol sm="12" class="mt-3">
                                <h3 class="custom-14px-500 font-color-AEAEB2">HRDF Contribution</h3>
                                <v-select v-model="selectedHRDF" :options="hrdfOptions" label="status"></v-select>
                            </CCol>
    
                            <CCol sm="12" class="mt-3">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Standard Working Hour</h3>
                                <CInput type="number" v-model="StandardWorkingHour" />
                            </CCol>
    
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
                            <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitPaymentSetting">
                                        Save</CButton>
                                </div>
                            </CCol>
    
    
                        </CRow>
    
    
                    </div>
                </div>
    
                <div v-if="activeButton === 'approval'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717">Payment Approval</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Enable Approval</h3>
                            </CCol>
                            <CCol sm="1">

                                <CSwitch class="mx-1" variant="3d" color="primary" v-bind="labelIcon" type="checkbox" name="enable" :checked="IsEnable" @update:checked="(val) => {
            IsEnable = val; 
            radio = val; 
          }" /> 
                                <!-- <CSwitch 
    color="primary" 
    class="mx-1 custom-border-purple mt-1" 
    name="switch1" 
    :checked="IsEnable"
    shape="pill" 
/> -->
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Choose Approval Level</h3>
                                <v-select v-model="selectedApprover" :options="approver" label="Name" @input="onApproverChange"></v-select>
                            </CCol>
    
                            <CCol sm="12" class="mt-3">
                                <h3 class="custom-14px-500 font-color-171717">{{ selectedApprover ? selectedApprover.Name : 'Select an Approver' }}</h3>
                                <v-select v-model="selectedApprover2" :options="approverOptions" label="FullName"></v-select>
                            </CCol>
                            <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitApprover()">
                                        Save</CButton>
                                </div>
                            </CCol>
    
    
                        </CRow>
    
    
                    </div>

                    <v-client-table :data="listapp" :columns="columnsPaymentApprover" :options="options" class="custom-table" v-if="listapp.length > 0">
                                <template v-slot:No="{ row, index }">
            <label class="custom-12px-500">{{ index }}</label>
</template>

<template v-slot:FirstApprovalLevel="{ row }">
    <label class="custom-12px-500">{{ row.FirstAppUser }}</label>
    <br />
    Enable Approver:<CBadge color="success" v-if="row.IsFirstApp === true">Yes</CBadge>
    <CBadge color="danger" v-else>No</CBadge>
</template>

<template v-slot:SecondApprovalLevel="{ row }">
    <label class="custom-12px-500">{{ row.SecondAppUser }}</label>
    <br />
    Enable Approver:<CBadge color="success" v-if="row.IsSecondApp === true">Yes</CBadge>
    <CBadge color="danger" v-else>No</CBadge>
</template>

<template v-slot:ThirdApprovalLevel="{ row }">
    <label class="custom-12px-500">{{ row.ThirdAppUser }}</label>
    <br />
    Enable Approver:<CBadge color="success" v-if="row.IsThirdApp === true">Yes</CBadge>
    <CBadge color="danger" v-else>No</CBadge>
</template>
<template v-slot:Action="{ row }">
    <div class="d-flex">
        <img :src="require('@/assets/img/edit.png')" alt="Print" style="cursor: pointer;width:30px" @click="printRow(row.Index)" />
        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
    </div>
</template>

              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div>

                </div>
    
                <div v-if="activeButton === 'unpaid'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717">Unpaid Leave Setting</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Count Approved Unpaid Leave into Payroll</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Wage Calculation</h3>
                                <CSelect></CSelect>
                            </CCol>
    
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Unpaid Leave Cut-off Date</h3>
                                <CSelect></CSelect>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Count Mode</h3>
                                <CSelect></CSelect>
                            </CCol>
                            <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
    
    
                        </CRow>
    
    
                    </div>
                </div>
    
                <div v-if="activeButton === 'claim'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717">Claim Setting</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Enable Count Approved Claim</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Choose Payment</h3>
                                <CSelect></CSelect>
                            </CCol>
    
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Claim Cut-off Date</h3>
                                <CSelect></CSelect>
                            </CCol>
                            <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
    
    
                        </CRow>
    
    
                    </div>
                </div>
    
                <div v-if="activeButton === 'overtime'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717">Overtime Setting</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Enable Count Approved Overtime</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Choose Payment</h3>
                                <CSelect></CSelect>
                            </CCol>
    
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Wage Calculation</h3>
                                <CSelect></CSelect>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Overtime Cut-off Date</h3>
                                <CSelect></CSelect>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Compensation Rounded</h3>
                                <CSelect></CSelect>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Overtime Working Days in Month</h3>
                                <CSelect></CSelect>
                            </CCol>
                            <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
    
    
                        </CRow>
    
    
                    </div>
                </div>
                <div v-if="activeButton === 'lateness'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717">Lateness Setting</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Count Approved Lateness into Payroll</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
    
                            <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
    
    
                        </CRow>
    
    
                    </div>
                </div>
                <div v-if="activeButton === 'payslip'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717">Payslip Setting</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Template</h3>
                                <CSelect></CSelect>
                            </CCol>
    
    
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Show Overtime Remarks Details</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Show Unpaid Leave Remarks Details</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Show EPF Remarks Details</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Show HRDF Details</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="11">
                                <h3 class="custom-14px-500 font-color-171717">Show Year to Date Details</h3>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="12">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
    
    
                        </CRow>
    
    
                    </div>
                </div>
    
    
            </CCard>
        </CCol>
    
    
    
    
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            selectedCountries: "",
            countriesOptions: [],
            user: {},

            isPopupSuccess: false,

            activeButton: 'detail', // Default active button
            buttons: [
                { value: 'detail', label: 'Payment Setting', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'approval', label: 'Payment Approval', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'unpaid', label: 'Unpaid Leave Setting', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'overtime', label: 'Overtime Setting', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'lateness', label: 'Lateness Setting', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'payslip', label: 'Payslip Setting', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],

            options: {
                perPage: 5,
                pagination: true,
                filterable: false,
            },
            hrdfOptions: [{
                    id: 0,
                    status: "No",
                    value: false
                },
                {
                    id: 1,
                    status: "Yes",
                    value: true
                }

            ],
            selectedHRDF: "",
            StandardWorkingHour: 8,

            HRDF: "",
            Currency: "",

            approver: [],
            selectedApprover: "",

            selectedApprover2: {},
            approverOptions: [],
            IsEnable: false,
            listapp:[],

            columnsPaymentApprover: [
                'No',
                'FirstApprovalLevel',
                'SecondApprovalLevel',
                'ThirdApprovalLevel',
                'Action',
            ],








        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetListCountries();
                await this.GetCompanyPaymentSetting();
                await this.GetListTypeApprover();
                await this.GetListStaffApproval();
                await this.GetListApproverPerSetting();
            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        GoToSetting() {
            this.$router.push("Setting");
        },
        async GetListCountries() {
            try {
                const response = await this.$API.get(this.$GetCountry);
                if (response.status === 200) {
                    this.countriesOptions = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyPaymentSetting() {
            try {
                const response = await this.$API.get(this.$GetCompanyPaymentSetting, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.HRDF = this.info.HrdfContribution;
                        this.StandardWorkingHour = this.info.StandardWorkingHour;
                        this.Currency = this.info.currency;
                        this.SetupSelectedOption();
                    }
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListTypeApprover() {
            try {
                const response = await this.$API.get(this.$GetListTypeApprover, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.approver = response.data;

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListApproverPerSetting() {
            try {
                const response = await this.$API.get(this.$GetListApproverPerSetting + "?settingId=4", {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.listapp = response.data;

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        SubmitPaymentSetting() {

            const formData = new FormData();
            formData.append("CountryId", this.selectedCountries.Id);
            formData.append("HRDFContribution", this.selectedHRDF.value);
            formData.append("StandardWorkingHour", this.StandardWorkingHour);
            formData.append("Status", true);


            this.$API
                .post(this.$InsertStorePaymentSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    } else if (response.status === 200) {
                        this.isPopupSuccess = true;
                        this.GetSettingTimeOff();
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
        SetupSelectedOption() {


            this.selectedCountries = _.find(this.countriesOptions, { CountrySymbol: this.Currency });
            this.selectedHRDF = _.find(this.hrdfOptions, { value: this.HRDF });

        },
        async GetListStaffApproval() {
            try {
                const response = await this.$API.get(this.$GetListAllStaffWoPagination, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.approverOptions = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        onApproverChange(selected) {
            if (selected) {
                console.log('Selected Approver:', selected);
                // You can filter or handle any related logic when an approver is selected
            }
        },
        SubmitApprover() {
            const formData = new FormData();

            console.log('IsEnable:', this.IsEnable);

            if (this.selectedApprover) {
            if (this.selectedApprover.Name === "First Level Approver") {
                // If "First Level Approver" is selected
                formData.append("FirstAppUserId", this.selectedApprover2.Id);
                formData.append("IsFirstApproveEnable", this.IsEnable);
            } else if (this.selectedApprover.Name === "Second Level Approver") {
                // If "Second Level Approver" is selected
                formData.append("SecondAppUserId", this.selectedApprover2.Id);
                formData.append("IsSecondApproveEnable", this.IsEnable);
            }
                else if (this.selectedApprover.Name === "Third Level Approver") {
                // If "Second Level Approver" is selected
                formData.append("ThirdAppUserId", this.selectedApprover2.Id);
                formData.append("IsThirdApproveEnable", this.IsEnable);
            }

            else{}
        }
      
            formData.append("TypeSettingApprover", 4);

            this.$API
                .post(this.$InsertApprover, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.isPopupSuccess = true;
                        this.GetListApproverPerSetting();

                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },




    }

};
</script>